import { DeepReadonly } from 'ts-essentials';

export type ParticipantRef =
  | {
      type: 'SIGNER';
      order: number;
      name?: string | null;
      dataLabel: string;
    }
  | {
      type: 'HOST';
      name?: string | null;
      dataLabel: string;
    }
  | {
      type: 'REQUESTER';
      name?: string | null;
      dataLabel: string;
    };

export type AttachmentInformation = {
  id: string;
  title: string;
  file?: {
    url: string;
    name: string;
    extension: string;
    size: number;
  };
  documentId?: string;
  participantReference: ParticipantRef;
};

export function getAttachedAttachments(attachments: DeepReadonly<AttachmentInformation[]>) {
  const signerAttachments = attachments.filter((a) => a.participantReference.type === 'SIGNER');
  const requesterAttachments = attachments.filter(
    (a) => a.participantReference.type === 'REQUESTER'
  );

  return [
    ...signerAttachments
      .slice()
      .sort((a, b) => {
        if (a.participantReference.type === 'SIGNER' && b.participantReference.type === 'SIGNER') {
          return a.participantReference.order - b.participantReference.order;
        }
        return 0;
      })
      .filter((a) => a.file),
    ...requesterAttachments,
  ];
}
